import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { CurrencyHelper } from "~/helpers/currency_helper"

// This controller is used to open the multi domain search sidepanel,
// it also dispatches an event each time the selection changes.
export default class extends Controller {
  static get values() {
    return {
      url: String,
      selectedDomainIds: { type: Array, default: [] },
      allEmailsCount: Number,
    }
  }

  static get targets() {
    return ["loadingTemplate", "sidepanel", "row", "findPeopleBtn"]
  }
  setForm(event) {
    if (this.rowTargets.length === 0 && this.selectedDomainIdsValue.length > 0) {
      return
    }

    const url = event.params.url || this.urlValue
    TempFormHelper.create(
      url,
      "post",
      (form) => {
        if (this.selectedDomainIdsValue.length > 0) {
          this.selectedDomainIdsValue.forEach((domainId) => {
            TempFormHelper.addHiddenInput(form, "id[]", domainId)
          })
        }
      },
      this.sidepanelTarget,
    ).requestSubmit()
  }

  _selectedDomains() {
    return this.rowTargets.reduce((hash, row) => {
      if (this.selectedDomainIdsValue.includes(row.dataset.domainId)) {
        hash[row.dataset.domainName] = row.dataset.companyName
      }
      return hash
    }, {})
  }

  // This action is used to update the selected domains value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.dataSets) {
      this.selectedDomainIdsValue = event.detail.dataSets.map((dataSet) => dataSet.domainId).filter(Boolean)
    } else {
      this.selectedDomainIdsValue = []
    }

    this.#updateButtonText()
    this.dispatch("selectionChanged", { detail: { selectedDomains: this._selectedDomains() } })
  }

  #updateButtonText() {
    let emailsCount = 0

    if (this.selectedDomainIdsValue.length > 0) {
      this.selectedDomainIdsValue.forEach((domainId) => {
        emailsCount += Number(this.rowTargets.find((row) => row.dataset.domainId === domainId).dataset.emailsCount)
      })
    } else {
      emailsCount = this.allEmailsCountValue
    }

    const newText = i18n.t("js.multi_domain_search.find_people", {
      count: emailsCount,
      results: CurrencyHelper.numberWithDelimiter(emailsCount),
    })
    this.findPeopleBtnTarget.textContent = newText
  }
}
